<ion-header>
	<app-account-toolbar icon="person" title="account.title" (back)="goBack()"></app-account-toolbar>
</ion-header>
<ion-content *ngIf="customer">
	<ion-row class="ion-justify-content-center" role="region" aria-label="Centered content area">
		<ion-col class="ion-padding" size="12" size-lg="4" size-md="6">
			<h1 class="ion-no-margin">{{'account.title' | translate}}</h1>
			<h2 class="font-18">{{'account.contact' | translate}}</h2>
			<ion-radio-group [(ngModel)]="customer.gender" [disabled]="loading">
				<ion-row role="region" aria-label="Content Row">
					<ion-col class="ion-no-padding">
						<ion-item class="input" lines="none">
							<ion-label>{{'account.female' | translate}}</ion-label>
							<ion-radio [value]="gender.female" mode="md" slot="start"></ion-radio>
						</ion-item>
					</ion-col>
					<ion-col class="ion-no-padding">
						<ion-item class="input" lines="none">
							<ion-label>{{'account.male' | translate}}</ion-label>
							<ion-radio [value]="gender.male" mode="md" slot="start"></ion-radio>
						</ion-item>
					</ion-col>
					<ion-col class="ion-no-padding">
						<ion-item class="input" lines="none">
							<ion-label>{{'account.diverse' | translate}}</ion-label>
							<ion-radio [value]="gender.other" mode="md" slot="start"></ion-radio>
						</ion-item>
					</ion-col>
				</ion-row>
			</ion-radio-group>
			<ion-label>{{'account.name' | translate}}*</ion-label>
			<ion-item class="input" lines="none">
				<ion-input [(ngModel)]="customer.name" [disabled]="loading" name="name"></ion-input>
			</ion-item>
			<ion-label>{{'account.email' | translate}}*</ion-label>
			<ion-item class="input" lines="none">
				<ion-input [(ngModel)]="customer.email" [disabled]="loading" name="email"></ion-input>
			</ion-item>
			<ion-label>{{'account.phone' | translate}}*</ion-label>
			<ion-item class="input" lines="none">
				<ion-input [(ngModel)]="customer.phone" [disabled]="loading" name="phone"></ion-input>
			</ion-item>
			<ion-label>{{'account.street' | translate}}*</ion-label>
			<ion-item class="input" lines="none">
				<ion-input [(ngModel)]="customer.street" [disabled]="loading" name="street"></ion-input>
			</ion-item>
			<ion-label>{{'account.house' | translate}}*</ion-label>
			<ion-item class="input" lines="none">
				<ion-input [(ngModel)]="customer.number" [disabled]="loading" name="streetNumber"></ion-input>
			</ion-item>
			<ion-label>{{'account.zip' | translate}}*</ion-label>
			<ion-item class="input" lines="none">
				<ion-input [(ngModel)]="customer.postalCode" [disabled]="loading" name="postalCode"></ion-input>
			</ion-item>
			<ion-label>{{'account.city' | translate}}*</ion-label>
			<ion-item class="input" lines="none">
				<ion-input [(ngModel)]="customer.city" [disabled]="loading" name="city"></ion-input>
			</ion-item>
			<ion-label>{{'account.country' | translate}}*</ion-label>
			<ion-item class="input" lines="none">
				<ion-input
					[disabled]="loading"
					[ngModel]="'country.' + (customer.country ? customer.country : '').toLowerCase() | translate"
					name="country"
					readonly
				></ion-input>
			</ion-item>
			<ion-label>{{'account.floor' | translate}}</ion-label>
			<ion-item class="input" lines="none">
				<ion-input [(ngModel)]="customer.floor" [disabled]="loading" name="etage"></ion-input>
			</ion-item>
			<ion-label>{{'account.company' | translate}}</ion-label>
			<ion-item class="input" lines="none">
				<ion-input [(ngModel)]="customer.companyName" [disabled]="loading" name="companyName"></ion-input>
			</ion-item>
			<div (click)="deleteAccount()" class="delete-account pointer" role="button" tabindex="0">
				<ion-icon src="/assets/icon/delete-account.svg" role="img" aria-label="Delete account icon"></ion-icon>
				<span>{{'account.delete' | translate}}</span>
			</div>
		</ion-col>
	</ion-row>
</ion-content>
<ion-content *ngIf="!customer" class="ion-padding">
	<ion-row class="center" role="region" aria-label="Center content">
		<ion-spinner></ion-spinner>
	</ion-row>
</ion-content>
<ion-footer>
	<ion-row class="ion-justify-content-center">
		<ion-col class="ion-padding" size="12" size-lg="4" size-md="6">
			<ion-button (click)="saveCustomer()" *ngIf="!loading" expand="block">{{'account.save' | translate}}</ion-button>
			<ion-spinner *ngIf="loading"></ion-spinner>
		</ion-col>
	</ion-row>
</ion-footer>
